/* @flow */

import { simpleButtonActionMaker } from '@website/components/ActionMakers'

export default dispatcher => ({
  getButtonActions: simpleButtonActionMaker(dispatcher)
})
